import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../config/firebase-config';
import MembershipBenefits from './MembershipBenefits';
import MembershipForm from './MembershipForm';
import './MembershipPage.css';

const MembershipPage = () => {
  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  const handleContactUsClick = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/contact-form');
    }
  };

  return (
    <div className="membership-page" id="membership">
      <div className="membership-header">
        <h1>Become a Nur Al Huda Member School</h1>
        <p className="membership-subtitle">Join other Islamic schools across North America leveraging AI to enhance education</p>
      </div>

      <div className="membership-content">
        <div className="membership-benefits-section">
          <MembershipBenefits />
        </div>

        <div className="membership-price-card">
          <div className="price-ribbon">SPECIAL OFFER</div>
          <h2>School Membership</h2>
          <div className="price-container">
            <span className="price-amount">$250</span>
            <span className="price-period">per year</span>
          </div>
          <ul className="price-features">
            <li>Access for all school administrators</li>
            <li>5 teacher training sessions</li>
            <li>AI implementation consultation</li>
            <li>Monthly newsletter with AI updates</li>
            <li>Priority support</li>
          </ul>
          <div className="cta-buttons">
            <a href="#membership-form" className="primary-button">Join Now</a>
            <button className="secondary-button" onClick={handleContactUsClick}>Request Demo</button>
          </div>
        </div>
      </div>

      {/* <div className="section-divider"></div>

      <div className="testimonials-section">
        <h2>Trusted by Islamic Schools</h2>
        <div className="testimonials-container">
          <div className="testimonial-card">
            <div className="testimonial-content">
              "Nur Al Huda's AI solutions have transformed how we manage student data and communicate with parents. Our staff saved hours each week."
            </div>
            <div className="testimonial-author">
              <p className="author-name">Br. Abdullah Rahman</p>
              <p className="author-role">Principal, Al-Huda Academy</p>
            </div>
          </div>
          <div className="testimonial-card">
            <div className="testimonial-content">
              "The teacher training on AI tools was excellent. Our teachers now confidently incorporate AI in their lesson planning while maintaining Islamic values."
            </div>
            <div className="testimonial-author">
              <p className="author-name">Sr. Aisha Johnson</p>
              <p className="author-role">Vice Principal, Iman Islamic School</p>
            </div>
          </div>
        </div>
      </div> */}

      <div className="section-divider"></div>

      <div id="membership-form" className="membership-form-section">
        <h2>Sign Up Your School</h2>
        <p>Complete the form below to join our network of member schools</p>
        <MembershipForm />
      </div>

      <div className="section-divider"></div>

      <div className="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-items">
          <div className="faq-item">
            <h3>What is included in the school membership?</h3>
            <p>The Nur Al Huda school membership includes AI implementation consultation, teacher training sessions, monthly newsletters with AI updates for education, access to our school management system, and priority support for all your questions.</p>
          </div>
          <div className="faq-item">
            <h3>How many staff members can access the platform?</h3>
            <p>All school administrators and teachers can access the platform with your membership. There are no user limits within your organization.</p>
          </div>
          <div className="faq-item">
            <h3>Do you provide Islamically appropriate AI tools?</h3>
            <p>Yes, all our AI tools and content are reviewed to ensure they align with Islamic values and principles. We understand the unique needs of Islamic schools and design our solutions accordingly.</p>
          </div>
          <div className="faq-item">
            <h3>Is there a trial period available?</h3>
            <p>Yes, we offer a 30-day trial for schools to experience our platform. Contact us for a demo and trial access.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MembershipPage; 